var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9435 63.04C38.6324 63.68 35.9911 64 33.3499 64C15.1911 64 0.333984 49.6 0.333984 32C0.333984 14.4 15.1911 0 33.3499 0C37.6419 0 41.934 0.96 45.8959 2.24L40.6133 7.36C38.3022 6.72 35.9911 6.4 33.3499 6.4C18.8229 6.4 6.93716 17.92 6.93716 32C6.93716 46.08 18.8229 57.6 33.3499 57.6C34.6705 57.6 36.3213 57.6 37.6419 57.28C38.3022 59.52 39.6229 61.44 40.9435 63.04ZM19.8134 25.92L15.1911 30.4L30.0483 44.8L63.0641 12.8L58.4419 8.32L30.0483 35.84L19.8134 25.92ZM53.1594 38.4V48H43.2546V54.4H53.1594V64H59.7626V54.4H69.6673V48H59.7626V38.4H53.1594Z",
    fill: "#07A568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTask);
export default __webpack_public_path__ + "static/media/new-task.3c75d2afc00daba4514b153533056a4a.svg";
export { ForwardRef as ReactComponent };